/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingConfigSnapshotResponseGradeProjectorAnyOf } from './gradingConfigSnapshotResponseGradeProjectorAnyOf';

export type GradingConfigSnapshotResponseGradeProjector = GradingConfigSnapshotResponseGradeProjectorAnyOf | null;
